module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addTemplate
    }
  }, [_vm._v("添加产品")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "产品名称",
      "size": "mini"
    },
    model: {
      value: (_vm.params.product_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "product_name", $$v)
      },
      expression: "params.product_name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchData
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.catesList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product_name",
      "label": "产品名称",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', [_vm._v(_vm._s(scope.row.product_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "plan_code",
      "label": "产品代码",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', [_vm._v(_vm._s(scope.row.plan_code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "buy_mode",
      "label": "购买方式",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.buy_mode == 1) ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("满额赠送")]) : (scope.row.buy_mode == 2) ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("关联商品")]) : _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("其他")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDialogGoods(scope.row, scope.row.id)
            }
          }
        }, [_vm._v("查看商品")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "premium",
      "label": "保费",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.premium) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "insured_amount",
      "label": "保额",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "align": "center",
      "label": "提交时间",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', [_vm._v(_vm._s(scope.row.created_at))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editAction(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加、编辑分类",
      "width": "40%",
      "visible": _vm.memberTagDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.memberTagDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "产品名称",
        "prop": "product_name",
        "rules": [{
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        }]
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "产品名称"
      },
      model: {
        value: (_vm.form.product_name),
        callback: function($$v) {
          _vm.$set(_vm.form, "product_name", $$v)
        },
        expression: "form.product_name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "产品代码",
        "prop": "plan_code",
        "rules": [{
          required: true,
          message: '请输入产品代码',
          trigger: 'blur'
        }]
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "产品代码"
      },
      model: {
        value: (_vm.form.plan_code),
        callback: function($$v) {
          _vm.$set(_vm.form, "plan_code", $$v)
        },
        expression: "form.plan_code"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "购买方式"
      }
    }, [_c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (_vm.form.buy_mode),
        callback: function($$v) {
          _vm.$set(_vm.form, "buy_mode", $$v)
        },
        expression: "form.buy_mode"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "1",
        "border": ""
      }
    }, [_vm._v("满额赠送")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "2",
        "border": ""
      }
    }, [_vm._v("关联商品")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "3",
        "border": ""
      }
    }, [_vm._v("其他")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "商城商品选择"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "55%"
      },
      attrs: {
        "filterable": "",
        "placeholder": "请输入商品货号",
        "remote": "",
        "remote-method": _vm.getItemShopsList,
        "multiple": ""
      },
      on: {
        "change": _vm.handleItemShopsChange
      },
      model: {
        value: (_vm.relItemsShops),
        callback: function($$v) {
          _vm.relItemsShops = $$v
        },
        expression: "relItemsShops"
      }
    }, _vm._l((_vm.relItemsShopsList), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    }, [_c('el-col', [_c('el-input', {
      model: {
        value: (_vm.form.goods_ids),
        callback: function($$v) {
          _vm.$set(_vm.form, "goods_ids", $$v)
        },
        expression: "form.goods_ids"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "保费"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "保费"
      },
      model: {
        value: (_vm.form.premium),
        callback: function($$v) {
          _vm.$set(_vm.form, "premium", $$v)
        },
        expression: "form.premium"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "保额"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "保额"
      },
      model: {
        value: (_vm.form.insured_amount),
        callback: function($$v) {
          _vm.$set(_vm.form, "insured_amount", $$v)
        },
        expression: "form.insured_amount"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveCateData
      }
    }, [_vm._v("确定保存")])], 1)], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.goodsDialog.goodsTitle,
      "visible": _vm.goodsDialog.goodsVisible,
      "before-close": _vm.handleGoodsDialogCancel
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.goodsDialog, "goodsVisible", $event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "title": "商品列表",
      "type": "info",
      "description": "",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.goodsDialog.dialogLoading),
      expression: "goodsDialog.dialogLoading"
    }],
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 23
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.goodsList,
      "tooltip-effect": "dark"
    }
  }, [(false) ? _c('el-table-column', {
    attrs: {
      "prop": "item_id",
      "label": "商品id"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名称",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          staticClass: "btn-gap",
          attrs: {
            "to": {
              path: _vm.matchInternalRoute('goodsphysical_editor') + '/' + scope.row.item_id
            }
          }
        }, [_vm._v(_vm._s(scope.row.item_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品编号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }]
        }, [_vm._v("商品id:" + _vm._s(scope.row.item_id))]), _vm._v(_vm._s(scope.row.item_bn))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品来源"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.item_from == 'store') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("店铺")]) : (scope.row.item_from == 'shop') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("商城")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brief",
      "label": "商品简介",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "销售价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "market_price",
      "label": "市场价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_record",
      "label": "商品图片",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "240",
            "trigger": "hover"
          }
        }, [_c('div', {
          staticStyle: {
            "overflow-y": "scroll",
            "overflow-x": "hidden",
            "height": "240px",
            "text-align": "center"
          }
        }, _vm._l((scope.row.pics), function(v) {
          return _c('img', {
            staticClass: "goods-popover-img",
            staticStyle: {
              "width": "92%"
            },
            attrs: {
              "src": v
            }
          })
        }), 0), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_c('img', {
          attrs: {
            "src": "/static/img/icon_img.png"
          }
        })])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "btn-gap",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.deleteGoodsAction(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.goodsDialog.goodsParams.page,
      "page-sizes": [100, 200, 300],
      "total": _vm.goodsList.total_count,
      "page-size": _vm.goodsDialog.goodsParams.pageSize
    },
    on: {
      "current-change": _vm.handleGoodsDialogCurrentChange,
      "size-change": _vm.handleGoodsDialogSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.goodsDialog.goodsParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.goodsDialog.goodsParams, "page", $event)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer position-left",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.goodsDialog.goodsVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.goodsDialog.goodsVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ea464396", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea464396"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/jingzhi/product/jingzhi_items.vue
// module id = 2963
// module chunks = 0